// @ts-nocheck
import * as React from "react"

// Components
import Loader from "../Loader";
import Banner from "../Banner";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Session = ({ setLoading, loading, data }: ComponentArticles) => {
    const imageRef = React.useRef(null);
    const nameImageRef = React.useRef(null);
    const sizeImageRef = React.useRef(null);
    const [thereIsImage, setThereIsImage] = React.useState(false);

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    const setPicture = ({ target }: any) => {
        const [file]: any = target.files;
        if (file) {
            imageRef.current.src = URL.createObjectURL(file);
            nameImageRef.current.textContent = file.name
            sizeImageRef.current.textContent = convertBytes(file.size)
            setThereIsImage(true)
        }
    }

    const removePicture = (e) => {
        e.preventDefault()
        setThereIsImage(false)
    }

    const convertBytes = (bytes: number) => {

        if (bytes > 1_000_000) {
            let kilobytes = bytes / 1024
            return `${Math.round(kilobytes / 1024)}MB`
        }
        return `${Math.round(bytes / 1024)}KB`
    }

    return (
        <main className="session">
            <Banner
                backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/session/bg-session.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/gallery/bg-gallery.jpg` }}
                textBanner={!loading ? 'Participa' : ''}
                textDescription={'Ingresa tu correo electrónico para participar tu obra de arte'}
            />
            <div className="session__content">
                <div className="session-container">
                    {/* LOGIN FORM */}
                    <form id="afLoginForm" action="" className="af-form-session">
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email">Email</label>
                            <input id="email" type="email" />
                        </fieldset>
                        <input className="af-submit-button af-submit-button--block" type="submit" value="Enviar" />
                    </form>

                    {/* REGISTER FORM */}
                    <form id="afRegisterForm" action="" className="af-form-session">
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email">Email</label>
                            <input placeholder="emai l" id="email" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email2">Email2</label>
                            <input placeholder="email 2" id="email2" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email3">Email3</label>
                            <input placeholder="email 3" id="email3" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email4">Email4</label>
                            <input placeholder="email 4" id="email4" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email5">Email5</label>
                            <input placeholder="email 5" id="email5" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email6">Email6</label>
                            <input placeholder="email 6" id="email6" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <label htmlFor="email7">Email7</label>
                            <input placeholder="email 7" id="email7" type="email" />
                        </fieldset>
                        <fieldset className="af-form-session__field">
                            <input id="email8" type="checkbox" />
                            <label htmlFor="email8">He leído, entendido y aceptado los Términos y condiciones y el Aviso de privacidad</label>
                        </fieldset>
                        <input className="af-submit-button af-submit-button--block" type="submit" value="Enviar" />
                    </form>

                    {/* SUBMIT IMAGE FORM */}
                    <form action="" className="af-form-session">
                        <fieldset className="af-form-session__field">
                            <label htmlFor="picture" className={`af-picture ${thereIsImage ? 'af-picture--preparated' : ''}`}>
                                <section className="af-picture__first-state">
                                    <article className="af-picture__desc">
                                        <img src={`/${THEMEURL}/sources/dist/assets/images/icons/image-field.svg`} alt="" title="" />
                                        Sube tu imagen
                                        <small>Recuerda subir tu dibujo en formato JPG, PNG o PDF y que su tamaño no exceda 5MB</small>
                                    </article>
                                    <span className="af-choice-image">Elegir Imagen</span>
                                </section>
                                <section className="af-picture__second-state">
                                    <div className="af-picture__info">
                                        <img ref={imageRef} className="af-picture__image" src="" alt="" title="" />
                                        <article className="af-picture__name">
                                            <span ref={nameImageRef}></span><br /><span ref={sizeImageRef}></span>
                                        </article>
                                    </div>
                                    <div className="af-picture__actions">
                                        <button className="af-picture__remove" onClick={removePicture}></button>
                                    </div>
                                </section>
                            </label>
                            <input id="picture" type="file" onChange={setPicture} />
                        </fieldset>
                        <input className="af-submit-button af-submit-button--block" type="submit" value="Enviar" />
                    </form>
                </div>
            </div>
        </main>
    )
}

export default Loader(Session)